// extracted by mini-css-extract-plugin
module.exports = {"attachedDocumentActions":"attachedDocumentActions__dhH3V","button":"button__9dLba","edit":"edit__DioDH","compact":"compact__tOXtY"};